import Stylus from './Stylus';
import FrameDrawingBrush from './FrameDrawingBrush';

// Create new frame objects.
class StylusFrame extends Stylus {
  constructor({ controller }) {
    super({ controller });
  }

  activate() {
    const brush = new FrameDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  iconClass() {
    return 'fa-regular fa-frame';
  }

  cursor() {
    return 'crosshair';
  }

  description() {
    return 'Frame';
  }

  subMenuName(): string | null {
    return 'frames';
  }

  stylusId() {
    return 'frame';
  }
}

export default StylusFrame;
